const ERROR_CODE = {
  noAuth: "token not assign error",
  loginFailed: "login failed",
  notLogin: "not login",
  recallTimeout: "exceed recall time limit",
  userNotFound: "user not found",
  invalidPassword: "invalid password",
  registerUnique: "duplicate_unique_property_exists",
  sendMsgBlock: 'blocked'
};

export { ERROR_CODE };
